import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@store/hooks';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import { inventoryCreateAccount } from '@store/INV/Transactions/InvIssue/invSlice';
import confirmAction from '@components/Shared/Alert/confirmAction';
import { useState } from 'react';

interface Props {
  selectedTransactions: any[];
  onclose: (ev: any) => void;
}

const AddCreateAccount = ({ selectedTransactions, onclose }: Props) => {
  const { t, i18n } = useTranslation();
  const [responseData, setResponseData] = useState<any[]>([]);

  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      periodId: '',
      glDate: ''
    },
    // validationSchema: CreateAccountSchema(t),
    onSubmit: async () => {
      const ids = selectedTransactions?.map(m => m.id);

      const body = {
        transections: ids
        // periodId: values.periodId,
        // glDate: values.glDate,
      };

      const confirm = await confirmAction('');

      if (!confirm) {
        formik.setSubmitting(false);
        return;
      }

      dispatch(inventoryCreateAccount(body))
        .unwrap()
        .then(res => {
          if (res.succeeded) {
            setResponseData(res.data || []);
            CustomAlert({
              action: 'info',
              msg: t('PostSuccessMessage')
            });
          } else {
            CustomAlert({
              action: 'Error',
              msg: res.message
            });
          }
        })
        .catch(error => {
          console.log(error);
          CustomAlert({ action: 'Error', msg: error });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  return (
    <>
      <div className='table-responsive  mb-2'>
        <table className='table  table-sm table-bordered'>
          <thead className='bg-theme bg-opacity-10 '>
            <tr>
              <th className='pt-2 pb-2'>{t('نوع العمليــة')}</th>
              <th className='pt-2 pb-2'>{t('الرقم')}</th>
              <th className='pt-2 pb-2'>{t('Date')}</th>
              {/* <th className="pt-2 pb-2">{t('Amount')}</th>  */}
            </tr>
          </thead>

          <tbody>
            {selectedTransactions?.map((item, index) => (
              <tr key={item.id}>
                <td className='align-middle'>{i18n.language === 'ar' ? item.transTypeName2 : item.transTypeName}</td>
                <td className='align-middle'>{item.code}</td>
                <td className='align-middle'>{item.transactionDate?.split('T')[0]}</td>
                {/* <td className="align-middle">
                  {i18n.language === 'en' ? item.peopleName : item.peopleName2}
                </td>
                <td className="align-middle">{item.invoiceDate?.toString()} </td>
                <td className="align-middle">{item.invoiceAmount}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {responseData.length > 0 && (
        <div className='mt-3'>
          {/* <h5 className="text-theme">{t('نتائج المعالجة')}</h5> */}
          <div className='table-responsive'>
            <table className='table table-sm table-bordered'>
              <thead className='bg-secondary text-white'>
                <tr>
                  <th className='pt-2 pb-2'>{t('code')}</th>
                  <th className='pt-2 pb-2'>{t('type')}</th>
                  <th className='pt-2 pb-2'>{t('activeFlag')}</th>
                  <th className='pt-2 pb-2'>{t('activeOutPeriod')}</th>
                  <th className='pt-2 pb-2'>{t('validOnDate')}</th>
                  <th className='pt-2 pb-2'>{t('errorMessage')}</th>
                  <th className='pt-2 pb-2'>{t('succeeded')}</th>
                </tr>
              </thead>

              <tbody>
                {responseData.map((item, index) => (
                  <tr key={index}>
                    <td className='align-middle'>{item.code}</td>
                    <td className='align-middle'>{i18n.language === 'en' ? item.type : item.type2}</td>
                    <td className='align-middle'>{item.activeFlag ? 'true' : 'false'}</td>
                    <td className='align-middle'>{item.activeOutPeriod}</td>
                    <td className='align-middle'>{item.validOnDate}</td>
                    <td className='align-middle'>{item.errorMessage}</td>
                    <td className='align-middle'>{item.succeeded ? 'true' : 'false'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Form onSubmit={formik.handleSubmit}>
        <div className='row'>
          <div className='col-6'>
            <button
              type='submit'
              className='btn btn-lg btn-theme  w-100 rounded-0'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {formik.isSubmitting ? (
                <div className='spinner-border spinner-border-sm me-2'></div>
              ) : (
                <i className='fas fa-lg fa-fw me-2 fa-check-circle'></i>
              )}
              {t('Post')}
            </button>
          </div>
          <div className='col-6'>
            <button
              type='button'
              className='btn btn-lg  btn-default   w-100 rounded-0'
              onClick={onclose}
              data-bs-dismiss='modal'
            >
              <i className='fas fa-times-circle fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddCreateAccount;
